namespace TabAurous.ProductDevelopment {
    export interface PDQuotationForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.ServiceLookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        PriceListId: Serenity.ServiceLookupEditor;
        MarkUpPolicyId: Serenity.LookupEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        GstVat: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ItemDetails: PDQuotationItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class PDQuotationForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.Quotation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PDQuotationForm.init)  {
                PDQuotationForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = PDQuotationItemsEditor;

                Q.initFormType(PDQuotationForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'PartyId', w3,
                    'LedgerName', w1,
                    'Address1', w4,
                    'State', w1,
                    'Country', w1,
                    'PriceListId', w3,
                    'MarkUpPolicyId', w5,
                    'TermsId', w2,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'CurrencyId', w5,
                    'ExchRate', w6,
                    'GstVat', w1,
                    'UserId', w5,
                    'EmployeeId', w2,
                    'ItemDetails', w7,
                    'FinancialYearId', w2,
                    'Pieces', w2,
                    'Weight', w6,
                    'NetWeight', w6,
                    'NetAmount', w6,
                    'CCNetAmount', w6,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'GrossAmount', w6,
                    'CCGrossAmount', w6,
                    'Remark', w4,
                    'ShipmentId', w2,
                    'ShipAddressId', w2,
                    'CompanyId', w2
                ]);
            }
        }
    }
}
